import { render, staticRenderFns } from "./TestingTools_writing.vue?vue&type=template&id=8766a442&scoped=true"
import script from "./TestingTools_writing.vue?vue&type=script&lang=js"
export * from "./TestingTools_writing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8766a442",
  null
  
)

export default component.exports